import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Table, TableFilterEvent, TableRowExpandEvent } from 'primeng/table';
import { CancelValidation, GetOrderForRenewResponse, ShortCodeLeaseDetailsResponse, ShortCodesService } from 'src/app/services/shortcodes.service';
import { AccountService } from 'src/app/services/account.service';
import { ScrAuthorizationService } from 'src/app/services/authorization.service';
import { Account } from 'src/app/models/account.model';
import { ConfirmationService, FilterMatchMode, SortEvent } from 'primeng/api';
import { TermLengthPipe, LeaseStatusPipe, LeaseTypePipe } from 'src/app/shared/table-data.pipe';
import { ShortCodesRole } from 'src/app/models/constants';
import { LabelValuePair, ScrBaseComponent } from 'src/app/components/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { CodeTransferDialogComponent } from '../code-transfers/transfer-dialog/code-transfer-dialog.component';
import { RouterService } from 'src/app/services/router.service';
import { Observable, first, of } from 'rxjs';
import { ScrBaseService, ScrMessage } from 'src/app/services/base.service';
import { LeaseSummary, LeaseSummaryResponse, LeasedCodeDetail } from 'src/app/models/lease.model';
import { TransferEvent } from '../code-transfers/code-transfers.component';
import { LeaseType } from 'src/app/models/constants';
import { MbOptOutUpdateEvent } from "src/app/shared/common-events";
import { HttpResponse } from '@angular/common/http';
import { ScrAuthenticationService } from 'src/app/services';
import { CancelShortCodeLeaseDialogComponent } from '../code-transfers/cancel-shortcodelease/cancel-shortcodelease-dialog.component';
import { CancelShortCodeLeaseConfirmationDialogComponent } from '../code-transfers/cancel-shortcodelease-confirmation/cancel-shortcodelease-confirmation-dialog.component';
import { isNumber } from 'lodash-es';


class Filter {
  leaseStatus: string[] = [];
  autorenew: string[] = [];
  selectedFilter: string[] = [];


  reset() {
    this.leaseStatus = [];
    this.autorenew = [];
    this.selectedFilter = [];
  }
}

interface PageState {
  lastPosition: number;
  lastTablePosition: number;
  shortCodeOrderToggle: boolean;
  searchFieldValue?: string;
  filtersVisible: boolean;
  scrollToShortCode?: number;
}

export interface LeaseSummaryArrayResults {
  results: LeaseSummary[];
}
@Component({
  selector: 'app-short-code-list',
  templateUrl: './short-code-list.component.html',
  styleUrls: ['./short-code-list.component.scss'],
  providers: [TermLengthPipe, LeaseStatusPipe, LeaseTypePipe],
})
export class ShortCodeListComponent extends ScrBaseComponent implements OnInit {
  public shortCodeList: LeaseSummary[] = [];
  public account: Account = {} as Account;
  public shortCodeDetails = new Map<number, object>();
  public checked = false;
  public brandsEnabled = true;
  licenseAgreementDate = '';
  public licenseAgreementcontent?: string;
  public bestPracticesContent?: string;
  public bestPracticesDate?: string;
  leaseInfo !: LeaseSummary;
  transferCode!: number;
  mbOptOutSc!: number;
  mbOptOutLease?: number = 0;
  mbOptOutUser!: string;
  mbOptOutMonthlyInvoiceId?: number;
  mbOptOutInvoiceDate?: string;
  isNotCarrierRegistrant = false;
  isMbOptOut = false;
  allTerms: LabelValuePair[] = [];
  allLeaseStatus: LabelValuePair[] = [];
  allAutorenew: LabelValuePair[] = [];


  buttonLabel = 'Show Filters';
  scfilter = new Filter();
  filtersVisible = false;
  filterKeys: string[] = [];

  termLength: TermLengthPipe = new TermLengthPipe();
  leaseStatusPipe: LeaseStatusPipe = new LeaseStatusPipe();
  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;
  scExpirDate?: string;

  public linkedAccountMode = false;

  message?: string = "";

  public orderSearchInput?: string;
  public shortCodeSearchInput?: string;

  leaseForBrandClientDialog?: LeaseSummary;

  showRegistryComments = false;
  registryComments = '';

  bulk: string[] = [];
  bulkLimit = 20;
  bulkSelectionCount = 0;
  bulkRenewFailures?: ScrMessage[];

  confirmationMessage?: string = "";
  informationMessage?: string = "";
  cancelScid!: number;
  cancelScOrderId!: number;
  leaseStatus?: string = "";
  statusReason?: string = "";
  shortCodeToNumeric = ScrBaseService.shortCodeToNumeric;

  @ViewChild('tt', { static: false }) tt!: Table;
  @ViewChild('globalSearch', { static: false }) globalSearch!: ElementRef;
  @ViewChild(CodeTransferDialogComponent, { static: false }) dialog!: CodeTransferDialogComponent;
  @ViewChild(CancelShortCodeLeaseDialogComponent, { static: false }) cancelShortCodeLeasedialog!: CancelShortCodeLeaseDialogComponent;
  @Input() listMode = 'default';
  @ViewChild(CancelShortCodeLeaseConfirmationDialogComponent, { static: false }) cancelShortCodeLeaseConfirmationDialog!: CancelShortCodeLeaseConfirmationDialogComponent;
  @Output() resultsLoaded = new EventEmitter<LeaseSummaryArrayResults>();
  activeModal = '';
  optOutMsg = '';

  // location of clicked table row.
  scrollToShortCode?: number;
  detailsLoading = false;

  JSON = JSON;

  @Input() actionInterceptor?: (accountId: number, fct: () => void) => void = undefined;
  @Input() actionInterceptorSelf?: object = undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shortCodesService: ShortCodesService,
    private accountService: AccountService,
    private configService: ConfigService,
    private confirmationService: ConfirmationService,
    private scrAuthorizationService: ScrAuthorizationService,
    private scrAuthenticationService: ScrAuthenticationService,
    private routerService: RouterService) {

    super();

    this.allAutorenew = [
      { label: 'Enrolled', value: true },
      { label: 'Not Enrolled', value: false },
    ];

    this.scfilter.leaseStatus = [];
    this.scfilter.autorenew = [];
    this.scfilter.selectedFilter = [];
  }

  canDeactivate(): boolean {
    // if the table was never shown (e.g. no results found), don't try to save the current state.
    if (this.tt?.wrapperViewChild) {
      const state: PageState = {
        lastPosition: window.scrollY,
        lastTablePosition: this.tt.wrapperViewChild.nativeElement.scrollTop,
        shortCodeOrderToggle: this.checked,
        searchFieldValue: this.checked ? this.orderSearchInput : this.shortCodeSearchInput,
        filtersVisible: this.filtersVisible,
        scrollToShortCode: this.scrollToShortCode
      };
      localStorage.setItem('windowstate.shortcodelist', JSON.stringify(state, undefined, 2));
      this.tt.stateKey = 'windowstate.shortcodelist.table';
      this.tt.saveState();
    }
    else {
      localStorage.removeItem('windowstate.shortcodelist');
    }

    return true;
  }


  determineListAPI(): Observable<LeaseSummaryResponse> {

    if (this.listMode.toLowerCase() === 'needsaction') {
      return this.shortCodesService.getCustomQueryShortCodeList('1', '10', 'needsaction');
    }
    else if (this.listMode.toLowerCase() === 'linkedaccounts-needsaction') {
      return this.shortCodesService.getCustomQueryShortCodeList('1', '10', 'linkedaccounts-needsaction');
    }
    else if (this.listMode.toLowerCase() === 'linkedaccounts') {
      return this.shortCodesService.getCustomQueryShortCodeList('1', '10', 'linkedaccounts');
    }
    else if (this.listMode.toLowerCase() === 'bulkrenew') {
      return this.shortCodesService.getCustomQueryShortCodeList('1', '10', 'bulkrenew');
    } else {
      return this.shortCodesService.getShortCodesList('1', '10');
    }
  }

  ngOnInit(): void {
    // this.tt.globalFilterFields.push('scId');

    this.linkedAccountMode = (this.listMode === 'linkedaccounts' || this.listMode === 'linkedaccounts-needsaction');

    this.scrAuthorizationService.getAuthorizedGroups().subscribe((groups: string[]) => {
      if (groups && [ShortCodesRole.CarrierRegistrant, ShortCodesRole.Carrier].some((val: string) => groups.includes(val))) {
        this.allLeaseStatus = [
          { label: 'Approved', value: 'Approved' },
          { label: 'Cancelled', value: 'Cancelled' }
        ];
      } else {
        if (this.listMode === 'bulkrenew') {
          this.allLeaseStatus = [
            { label: 'Approved', value: 'Approved' },
            { label: 'Cancelled', value: 'Cancelled' }
          ];
        }
        else {
          this.allLeaseStatus = [
            { label: 'Approved', value: 'Approved' },
            { label: 'Pending Renew', value: 'PendingRenew' },
            { label: 'Pending New', value: 'PendingNew' },
            { label: 'Cancelled', value: 'Cancelled' }
          ];
        }
      }
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.forkedObserve<any>([
      this.determineListAPI(),
      this.accountService.getAccount(),
      this.configService.getConfig(),
      this.scrAuthorizationService.getAuthorizedGroups()], (rsp) => {

        this.brandsEnabled = rsp[2].brandsEnabled;
        this.licenseAgreementDate = rsp[2].licenseAgreement.updated;
        this.licenseAgreementcontent = rsp[2].licenseAgreement.content;
        this.bestPracticesContent = rsp[2].bestPractices?.content;
        this.bestPracticesDate = rsp[2].bestPractices?.updated;
        this.isNotCarrierRegistrant = !(rsp[3].includes(ShortCodesRole.CarrierRegistrant) || rsp[3].includes(ShortCodesRole.Carrier));

        if (rsp[2].maxCartItems) {
          this.bulkLimit = rsp[2].maxCartItems;
        }

        this.account = rsp[1].account;

        if (this.account.monBillEnabled) {
          if (this.listMode === 'bulkrenew') {
            this.allTerms = [
              { label: '3-Month', value: 3 },
              { label: '6-Month', value: 6 },
              { label: '12-Month', value: 12 }
            ];
          }
          else {
            this.allTerms = [
              { label: '1-Month', value: 1 },
              { label: '3-Month', value: 3 },
              { label: '6-Month', value: 6 },
              { label: '12-Month', value: 12 },
              { label: 'Billed Monthly', value: 14 },
            ];
          }
        } else {
          this.allTerms = [
            { label: '3-Month', value: 3 },
            { label: '6-Month', value: 6 },
            { label: '12-Month', value: 12 },
          ];
        }

        this.processTableData(rsp[0].data.leases);
        return false; // no message
      });

  }

  /**
   * Upload table reload or during the ngOnInit processing, we have a list of
   * short codes and need to reload the primeng table.
   */
  processTableData(leases: LeaseSummary[]) {
    this.shortCodeList = leases;

    if (this.resultsLoaded) {
      this.resultsLoaded.emit({ results: this.shortCodeList });
    }

    this.shortCodeList.forEach(item => {

      //Hack to filter
      if (item.leaseType === 'BilledMonthly') {
        item.term = Number(14).valueOf();
      }

      item.termXm = this.termLength.transformscfilter(item.term, item.leaseType);
      item.leaseStatusXm = this.leaseStatusPipe.transform(item.leaseStatus, item.statusReason);
    });

    this.updateActionButtons();

    // Table does not exist until later due to ngIf. Wait for it to exist before filtering.
    setTimeout(() => {

      if ((this.tt && this.route.snapshot.paramMap.get('scId'))) {
        this.globalSearch.nativeElement.value = this.route.snapshot.paramMap.get('scId');
        this.tt.filterGlobal(this.route.snapshot.paramMap.get('scId'), 'contains');
      }

      if (this.tt && this.route.snapshot.paramMap.get('orderId')) {
        this.globalSearch.nativeElement.value = this.route.snapshot.paramMap.get('orderId');
        this.tt.globalFilterFields = ['orderId'];
        this.orderSearchInput = this.route.snapshot.paramMap.get('orderId') || '';
        this.checked = true;
        this.tt.filterGlobal(this.route.snapshot.paramMap.get('orderId'), FilterMatchMode.EQUALS);
      }

      if (history.state?.scId) {
        this.globalSearch.nativeElement.value = history.state?.scId;
        this.tt.filterGlobal(history.state?.scId, 'contains');
        this.getShortCodeDetails(history.state?.scId);
      }

      if (history.state?.orderId) {
        this.globalSearch.nativeElement.value = history.state?.orderId;
        this.tt.globalFilterFields = ['orderId'];
        this.orderSearchInput = history.state?.orderId || '';
        this.checked = true;
        this.tt.filterGlobal(history.state?.orderId, FilterMatchMode.EQUALS);
      }

      // if user is coming back to the short code list from one of the routes below, we should restore their state.
      const currentPath = this.routerService.getCurrentUrl();
      const prevPath = this.routerService.getPreviousUrl();


      if (currentPath.includes('my-shortcode-tab:shortcode-list') && !prevPath.includes('monthly-invoice') &&
        ((prevPath.includes('receipt') || prevPath.includes('invoice') || prevPath.includes('statement') || prevPath.includes('details') || prevPath.includes('billingDetails') ||
          prevPath.includes('multiPaymentReceipt') || prevPath.includes('order-code')))) {
        const liststorage = localStorage.getItem('windowstate.shortcodelist');
        if (liststorage) {
          // this took some effort so will document what happened.
          // when we left the page, we saved the scroll position of the page and table and told the table to save its state.
          // restoreState is called but that doesn't seem to restore the sorting.  So call sortMultiple.
          // However, calling sortMultiple wipes out the expanded rows so save those first, call sort, then restore them.
          // For each of the expanded items, we need to load the details.  Rather than individual calls for each one,
          // we combine these into a single API call for details.
          const state: PageState = JSON.parse(liststorage);

          this.filtersVisible = state.filtersVisible;
          this.checked = state.shortCodeOrderToggle;
          if (this.checked) {
            this.orderSearchInput = state.searchFieldValue;
          }
          else {
            this.shortCodeSearchInput = state.searchFieldValue;
          }
          if (state.searchFieldValue) {
            this.onSlide();
          }


          this.tt.stateKey = 'windowstate.shortcodelist.table';
          this.tt.restoreState();
          if (this.filtersVisible) {
            this.tt._filter();
          }
          const expandedRows = Object.assign({}, this.tt.expandedRowKeys);
          let keys = Object.keys(expandedRows);
          this.tt.sortMultiple();

          // setting it updates the table after the sort.
          this.tt.expandedRowKeys = expandedRows;

          // console.debug('expanded: ' + JSON.stringify(keys));
          if (keys.length > 30) {
            keys = keys.slice(0, 30);
          }
          // make sure the one we want to scroll to is in the list.
          if (state.scrollToShortCode) {
            const k = `${state.scrollToShortCode}`;
            if (!keys.includes(k)) {
              keys.push(k);
            }
          }

          if (keys.length > 0) {
            this.detailsLoading = true;
            // ask the server for details about each of the expanded items.  We do not save it locally anymore.
            this.observe(this.shortCodesService.getMultiLeasedCodeDetail(keys, true), (rsp: ShortCodeLeaseDetailsResponse) => {
              this.detailsLoading = false;
              rsp.results.forEach(result => {
                const itemInList = this.shortCodeList.find(item => item.scId === result.lease.scId);
                if (itemInList) {
                  itemInList.details = result;
                  this.shortCodeDetails.set(itemInList.scId, result);
                  const e: TableRowExpandEvent = { data: itemInList, originalEvent: new Event('click') };
                  this.tt.onRowExpand.emit(e);
                }
                else {
                  console.warn('received details for ' + result.lease.scId + ' that was not in the list');
                }
              });

              setTimeout(() => {

                if (state.scrollToShortCode) {
                  const k = `row_${state.scrollToShortCode}`;
                  const row = document.getElementById(k);
                  if (row) {
                    // console.debug('found row ' + row + ' ' + row.offsetTop + ' ' + row.offsetHeight);
                    // console.debug('filter shown ' + this.filtersVisible);
                    let top = row.offsetTop - row.offsetHeight;
                    if (this.filtersVisible) {
                      top -= row.offsetHeight; // add some more for the filter row.
                    }
                    this.tt.scrollTo({ top });
                  }
                  else {
                    this.log.trace(`short code ${state.scrollToShortCode} not found in list.  No row to scroll to.`);
                  }
                }
                window.scrollTo({ top: state.lastPosition });
              }, 50);

              return false;
            });
          }
          else {
            this.tt.scrollTo({ top: state.lastTablePosition });
            window.scrollTo({ top: state.lastPosition });
          }
        }
      }
      localStorage.removeItem('windowstate.shortcodelist');
      localStorage.removeItem('windowstate.shortcodelist.table');


    }, 250);

    return false; // no message

  }


  /**
   * Load the short code details.  If the details are in the local cache, use it.
   * @param scId - short code to be retrieved.
   */
  getShortCodeDetails(scId: number) {
    if (!this.shortCodeDetails.get(scId)) {
      this.loadShortCodeDetails(scId);
    }
  }

  /**
   * Fetch the details about a short code.
   * @param scId - id of short code to be retrieved.
   */
  loadShortCodeDetails(scId: number) {
    this.detailsLoading = true;
    this.observe(this.shortCodesService.getLeasedCodeDetail(scId), (rsp) => {
      this.detailsLoading = false;
      const details = rsp.results.find(r => r.lease.scId === scId);
      if (details) {
        const item = this.shortCodeList.find(ls => ls.scId === scId);
        if (item) {
          item.details = details;
          this.updateSummary(item, details);
          this.updateActionButton(item);
          this.shortCodeDetails.set(scId, details);
          const e: TableRowExpandEvent = { data: item, originalEvent: new Event('click') };
          this.tt.onRowExpand.emit(e);
          if (details.lease.scExpirationDate) {
            this.scExpirDate = details.lease.scExpirationDate;
          }

        }
        else {
          console.warn('unexpected: short code detail response for ' + scId + ' but entry not found in list');
        }
      }
      return false;
    });
  }

  // after an action is performed, we need to update the 
  // summary info driving the list with details we fetched.
  updateSummary(summary: LeaseSummary, detail: LeasedCodeDetail) {
    summary.autorenew = detail.lease.autorenew ?? false;
    summary.leaseStatus = detail.lease.leaseStatus;
    summary.statusReason = detail.lease.statusReason;
    summary.leaseType = detail.lease.leaseType;
    summary.term = detail.lease.term ?? 12;
    if (summary.leaseType === 'BilledMonthly') {
      summary.term = 14;
      detail.lease.term = 14;
    }
    summary.termXm = this.termLength.transformscfilter(detail.lease.term, detail.lease.leaseType);
    summary.leaseStatusXm = this.leaseStatusPipe.transform(detail.lease.leaseStatus, detail.lease.statusReason);
    summary.scExpirationDate = detail.lease.scExpirationDate;

    summary.mbOptOutDate = detail.lease.mbOptOutDate;  // appears to be unused
    summary.orderSource = detail.lease.orderSource;    // appears to be unused
  }

  /**
   * Override the sort to handle customizations.  
   */
  customSort(event: SortEvent) {
    if (this.tt) {
      this.tt.expandedRowKeys = {};
    }

    if (!event.data) {
      return;
    }

    const data = event.data as LeaseSummary[];
    data.sort((a, b) => {
      let rv = 0;
      if (event.field === 'scId') {
        rv = a.scId - b.scId;
      }
      else if (event.field === 'autorenew') {
        if (a.autorenew && !b.autorenew) {
          rv = -1;
        }
        else if (!a.autorenew && b.autorenew) {
          rv = 1;
        }
      }
      else if (event.field === 'scExpirationDate') {
        if (!a.scExpirationDate) return -1;
        if (!b.scExpirationDate) return 1;

        const t1 = new Date(a.scExpirationDate).getTime();
        const t2 = new Date(b.scExpirationDate).getTime();
        rv = t1 < t2 ? -1 : t1 === t2 ? 0 : 1;
      }
      else if (event.field === 'term') {
        // count lease type of billed monthly as 14 (> 12 month term).
        if (a.leaseType === LeaseType.BilledMonthly && b.leaseType !== LeaseType.BilledMonthly) {
          rv = 1;
        }
        else if (a.leaseType !== LeaseType.BilledMonthly && b.leaseType === LeaseType.BilledMonthly) {
          rv = -1;
        }
        else if (a.leaseType === LeaseType.BilledMonthly && b.leaseType === LeaseType.BilledMonthly) {
          rv = 0;
        }
        else {
          rv = a.term - b.term;
        }
      }
      else if (event.field === 'orderId') {
        rv = (a.orderId > b.orderId ? 1 : a.orderId < b.orderId ? -1 : 0);
      }
      else if (event.field === 'leaseStatus') {
        rv = a.leaseStatus.localeCompare(b.leaseStatus);
        if (rv === 0) {
          if (!a.statusReason && b.statusReason) {
            rv = -1;
          }
          else if (!b.statusReason && a.statusReason) {
            rv = 1;
          }
          else if (a.statusReason && b.statusReason) {
            rv = a.statusReason.localeCompare(b.statusReason);
          }
        }
        // alternate for lease status sort using the pipe.
        // const asr = pipe.transform(a.leaseStatus, a.statusReason);
        // const bsr = pipe.transform(b.leaseStatus, b.statusReason);
        // if (asr && bsr) {
        //  rv = asr.localeCompare(bsr);
        // }
      }
      else if (event.field === 'linkedAccountName') {
        if (a.linkedAccountName && b.linkedAccountName) {
          rv = a.linkedAccountName.localeCompare(b.linkedAccountName);
        }
        else {
          rv = 0;
        }
      }



      if (event.order) {
        rv *= event.order;
      }

      if (rv === 0) {
        if (!a.scExpirationDate) return -1;
        if (!b.scExpirationDate) return 1;
        const t1 = new Date(a.scExpirationDate).getTime();
        const t2 = new Date(b.scExpirationDate).getTime();
        rv = t1 < t2 ? -1 : t1 === t2 ? 0 : 1;
      }
      return rv;
    });
  }

  clearFilter() {
    this.tt.clearFilterValues();
    if (this.shortCodeSearchInput) {
      this.tt.filterGlobal(this.shortCodeToNumeric(this.shortCodeSearchInput), 'contains');
    }
    else if (this.orderSearchInput) {
      this.tt.filterGlobal(this.orderSearchInput, 'contains');
    }
    else {
      this.tt.filterGlobal(undefined, 'contains');
    }
  }

  /**
   * Called when a filter is applied to the table.  We want to track
   * what columns are used in the filter to allow us to place the 
   * filter icon in the table header.
   * @param e - table filter event from primeng.
   */
  tableFiltered(e: TableFilterEvent) {
    this.filterKeys = [];
    if (e.filters) {
      Object.keys(e.filters).forEach(key => {
        if (e.filters && e.filters[key]?.value !== null &&
          (e.filters[key]?.value?.length && e.filters[key]?.value?.length !== 0)) {
          this.filterKeys.push(key);
        }
      });
    }
    // unclear why we collapse all rows on a sort.
    // try taking it out.
    //if (this.tt) {
    //  this.tt.expandedRowKeys = {};
    //}
  }

  /**
   * The Short Code vs Order ID switch was
   */
  onSlide(): void {
    if (this.checked) {
      this.tt.globalFilterFields?.pop();
      this.tt.globalFilterFields?.push('orderId');
      console.log('selected order Id slider');
      this.tt.filterGlobal('', 'contains');
    }
    if (!this.checked) {
      this.tt.globalFilterFields?.pop();
      this.tt.globalFilterFields?.push('scId');
      console.log('selected Sc Id slider');
      this.tt.filterGlobal('', 'contains');
    }
  }

  autorenewToggled(shortCode: LeaseSummary) {
    if (shortCode.details?.lease.autorenew) {
      shortCode.details.lease.suppressExpiryEmail = false;
    }
    if (shortCode.autorenew) {
      this.setOptIn(shortCode);
    } else {
      this.setOptOut(shortCode);
    }
  }

  suppressEmail(lease: LeaseSummary) {
    this.observe(this.shortCodesService.suppressEmail(lease), {
      onSuccess: (rsp) => {
        if (rsp.status === 'success') {
          return false;
        }
        else {
          if (lease.details) {
            lease.details.lease.suppressExpiryEmail = !lease.details?.lease.suppressExpiryEmail;
          }
          return true;
        }
      },
      onError: () => {
        if (lease.details) {
          lease.details.lease.suppressExpiryEmail = !lease.details?.lease.suppressExpiryEmail;
        }
      }
    });
  }

  blockAutoRenew(shortCode: LeaseSummary): boolean {
    if (shortCode.term == 1)
      return true;

    if (shortCode.leaseStatus == 'Cancelled' && !shortCode.autorenew)
      return true;

    if (!shortCode.details)
      return false;

    return false;
  }

  toggleFilter(): void {
    this.filtersVisible = !this.filtersVisible;
  }

  updateActionButtons() {
    this.shortCodeList.forEach(this.updateActionButton);
  }

  updateActionButton(shortCode: LeaseSummary) {
    shortCode.settings = {};
    if (shortCode.leaseType === 'Prepay') {
      if (shortCode.leaseStatus === 'PendingNew' || shortCode.leaseStatus === 'PendingRenew') {
        shortCode.settings.label = 'View/Pay Invoice';
        shortCode.settings.showButton = true;
        shortCode.settings.clickAction = 'invoice';
      }
      else if (shortCode.leaseStatus === 'Approved') {
        if (shortCode.autorenew) {
          shortCode.settings.showButton = false;
        }
        else {
          shortCode.settings.label = 'Renew';
          shortCode.settings.showButton = true;
          shortCode.settings.clickAction = 'renew';
        }
      }
      else if (shortCode.leaseStatus === 'Cancelled') {
        switch (shortCode.statusReason) {
          case 'NoRenew':
            shortCode.settings.label = 'Renew';
            shortCode.settings.showButton = true;
            shortCode.settings.clickAction = 'renew';
            break;
          case 'NoPay':
            shortCode.settings.label = 'View/Pay Invoice';
            shortCode.settings.showButton = true;
            shortCode.settings.clickAction = 'invoice';
            break;
          default:
            shortCode.settings.showButton = false;
            break;
        }
      }
      else {
        shortCode.settings.showButton = false;
      }
    }
    else if (shortCode.leaseType === 'BilledMonthly') {
      const expirDate = new Date(shortCode.scExpirationDate);
      const todayDate = new Date();
      const fourteenDaysBeforeExpirationMonth = new Date(
        new Date().setDate(
          new Date(
            `${expirDate.getMonth() + 1}/1/${expirDate.getFullYear()}`
          ).getDate() - 14
        )
      );
      const sevenDaysBeforeExpirationMonth = new Date(
        new Date().setDate(
          new Date(
            `${expirDate.getMonth() + 1}/1/${expirDate.getFullYear()}`
          ).getDate() - 7
        )
      );
      if (fourteenDaysBeforeExpirationMonth <= todayDate && sevenDaysBeforeExpirationMonth >= todayDate) {
        shortCode.settings.label = 'Remove from MB';
        shortCode.settings.showButton = true;
        shortCode.settings.clickAction = 'removefrommb';
      }
      else {
        shortCode.settings.showButton = false;
      }
    }
    else if (shortCode.leaseType === 'FreeCarrierCode' && !shortCode.autorenew) {
      if ((shortCode.leaseStatus === 'Approved') || (shortCode.leaseStatus === 'Cancelled' && shortCode.statusReason === 'NoRenew')) {
        shortCode.settings.label = 'Renew';
        shortCode.settings.showButton = true;
        shortCode.settings.clickAction = 'renew';
      }
      else {
        shortCode.settings.showButton = false;
      }
    }
    else {
      shortCode.settings.showButton = false;
    }
  }

  /*
    User has select the opt-in for auto renew.
  */
  setOptIn(shortCode: LeaseSummary) {
    let isexpLessthan5days = false;
    if (shortCode.details) {
      const expDate = new Date(shortCode.details.lease.scExpirationDate ?? '');
      const curDate = new Date();

      if (expDate.getTime() - curDate.getTime() <= 432000000) {
        isexpLessthan5days = true;
      }

    }

    let isexpLessthan5daysTxt = '';
    if (isexpLessthan5days && shortCode.details?.lease.leaseStatus === 'Approved') {
      isexpLessthan5daysTxt = `<b>Attention:</b> Since the current lease expiration date is already within 5 days, the short code will be 
      scheduled to automatically renew once you finalize the enrollment. Please ensure the default payment 
      method information on your account is correct.`;

    }

    this.confirmationService.confirm({
      message: `
       <p>
          You are about to enroll short code ${shortCode.scId} into the Auto-Renew service.
        </p>
        <p>
        By enrolling into Auto-Renew, you agree to have the Short Code Registry 
        charge your default payment method on file for each renewal until you explicitly opt out of Auto-Renew for
         this short code. Auto-renewals are processed 5 days prior to the expiration date of each short code 
         lease.
        </p>
        
       
       <p>
       ${isexpLessthan5daysTxt}
       
        </p>
       
        <p>
        Please click the OK button to finalize the enrollment and agree to the terms for Auto-Renew described in the
          <a href="${this.licenseAgreementcontent}" target="_blank">
            Short Code Registry's Registrant Sublicense Agreement
          </a> (last updated ${this.licenseAgreementDate}) and the 
          <a href="${this.bestPracticesContent}" target="_blank">Messaging Principles and Best Practices</a> (last updated ${this.bestPracticesDate}).
        </p>`,
      header: 'Opt-In to Auto-Renew',
      key: 'setOptIn',
      accept: () => {
        this.observe(this.shortCodesService.scOptAutoRenew(shortCode.scId, true), {
          onSuccess: (rsp) => {
            if (rsp.status === 'success') {
              this.updateActionButtons();
              this.confirmOptIn(shortCode, isexpLessthan5days);
              if (shortCode.details) {
                shortCode.details.lease.suppressExpiryEmail = false;
              }
              return false;
            }
            else {
              shortCode.autorenew = !shortCode.autorenew;
              return true;
            }
          },
          onFailure: () => {
            // restore the old value.
            shortCode.autorenew = !shortCode.autorenew;
            // show the message.
            return true;
          },
          onError: () => {
            shortCode.autorenew = !shortCode.autorenew;
          }
        });
      },
      reject: () => {
        shortCode.autorenew = !shortCode.autorenew;
      },
    });
  }

  confirmOptIn(shortCode: LeaseSummary, isexpLessthan5days: boolean) {
    let isexpLessthan5daysTxt = '';
    if (isexpLessthan5days && shortCode.details?.lease.leaseStatus === 'Approved') {
      isexpLessthan5daysTxt = `<b>Attention:</b> Since the current lease expiration date is within 5 days, the short code is scheduled to 
       automatically renew tonight.`;

    }
    this.confirmationService.confirm({
      message: `
        <p>
             You have successfully enrolled short code ${shortCode.scId} into Auto-Renew.
        </p>
        <p>
        The Short Code Registry will charge your default payment method on file for each renewal 
        until you explicitly opt out of Auto-Renew for this short code. Auto-renewals are processed 5 days prior to the expiration date of each short code lease.
        </p>
        <p>
         ${isexpLessthan5daysTxt}
        </p>`,
      header: 'Opt-In to Auto-Renew',
      key: 'confirmOptIn'
    });
  }

  doCancelTransfer(shortCode: number, toAccountId: string, transferId: number) {

    this.confirmationService.confirm({
      message:
        'Do you want to cancel the transfer of short code ' + shortCode + ' from your account to Account ID ' + toAccountId + '?',
      header: 'Cancel Transfer',
      key: 'cancelTransfer',
      accept: () => {
        this.observe(this.shortCodesService.cancelTransfer(transferId), {
          onSuccess: () => {
            this.shortCodeDetails.delete(shortCode);
            this.getShortCodeDetails(shortCode);
          }
        });
      }
    });
  }

  doMbOptOut(shortCode: LeaseSummary) {
    this.clearMessages();
    if (typeof (shortCode.leaseId) != 'undefined') {
      this.observe(this.shortCodesService.getMbOptOut(shortCode.leaseId), (res) => {
        this.mbOptOutLease = shortCode.leaseId as number;
        this.mbOptOutSc = shortCode.scId;
        this.leaseInfo = shortCode;
        this.isMbOptOut = true;
        this.mbOptOutUser = 'regUser';
        this.activeModal = 'mb-opt-out';
        this.optOutMsg = this.getFirstMessage(res) ?? '';
        return false;
      });
    }
  }

  onUpdateOptOut(e: MbOptOutUpdateEvent): void {
    this.onModalCancel();
    if (e.isCompleted && e.response) {
      // this.ngOnInit();
      this.mbOptOutMonthlyInvoiceId = e.response?.additionalData?.monthlyInvoiceId;
      this.mbOptOutInvoiceDate = e.response?.additionalData?.invoiceDate;
      this.shortCodeDetails.delete(this.mbOptOutSc);
      this.getShortCodeDetails(this.mbOptOutSc);

      this.activeModal = 'mb-opt-out-success';

      if (e.response.messages && e.response.messages.length > 0) {
        if (e.response.messages[0].code !== "2105") {
          this.displayLocalizedWarning('MB Opt Out succeeded but the cancellation failed');
          window.scrollTo(0, 0);
        }
      }
    }
  }

  onUpdateOptOutSuccess(): void {
    this.onModalCancel();
  }

  onModalCancel() {
    this.activeModal = '';

  }


  setOptOut(shortCode: LeaseSummary) {
    this.confirmationService.confirm({
      message:
        `Please confirm that you would like to remove short code ${shortCode.scId} from Auto-Renew.`,
      header: 'Opt-Out from Auto-Renew',
      key: 'setOptOut',
      accept: () => {
        this.observe(this.shortCodesService.scOptAutoRenew(shortCode.scId, false), {
          onSuccess: (rsp) => {
            if (rsp.status === 'success') {
              this.updateActionButtons();
              this.confirmOptOut(shortCode.scId);
              return false;
            }
            else {
              shortCode.autorenew = !shortCode.autorenew;
              return true;
            }
          },
          onError: () => {
            shortCode.autorenew = !shortCode.autorenew;
          }
        });
      },
      reject: () => {
        shortCode.autorenew = !shortCode.autorenew;
      },
    });
  }

  confirmOptOut(scId: number) {
    this.confirmationService.confirm({
      /* message: `<p>You have successfully Opted-Out from Auto-Renew for short code ${shortCode.scId}.<br><br>
 Short Code Auto-Renew provides Short Code Registry members the convenience and<br> 
 flexibility of extending the lease of their short code beyond its term expiration date via an<br>
 automatic credit card payment. You can still choose to "Opt-In" to Auto-Renew for short<br>
 codes on the Short Code List.</p>`,*/
      message: `<p>You have successfully removed short code ${scId} from Auto-Renew.</p>`,
      header: 'Opt-Out from Auto-Renew',
      key: 'confirmOptOut'
      //            accept: () => { },
      //            reject: () => { },
    });
  }

  monthlyShortCodeStatementDownload(scId: number): void {
    this.observeDownloadOrAny(this.shortCodesService.downloadMonthlyShortCodeStatement(scId), (res: HttpResponse<Blob>) => {
      this.shortCodesService.processBlobResponseDownload(res, 'application/pdf');
    });
  }

  canViewIndividualShortCodeReceipt(shortCode: LeaseSummary): boolean {
    if (shortCode.leaseType === 'BilledMonthly' && (shortCode.details?.monthlyReceiptDocumentId || shortCode.details?.parentMonthlyReceiptDocumentId)) {
      return true;
    }
    if (shortCode.leaseType === 'Prepay' && shortCode.details?.lease.mbOptOutDate && (shortCode.details.monthlyReceiptDocumentId || shortCode.details?.parentMonthlyReceiptDocumentId)) {
      return true;
    }
    return false;
  }

  clickIndividualReceiptButton(accountId: number, monthlyReceiptDocId: number, monthlyInvoiceId: number, parentMonthlyInvoiceId: number, scId: number) {
    if (monthlyReceiptDocId) {
      this.viewReceipt(undefined, accountId, monthlyInvoiceId, scId);
    }
    else if (parentMonthlyInvoiceId) {
      this.viewReceipt(undefined, accountId, parentMonthlyInvoiceId, scId);
    }
    else {
      console.error('no monthlyReceiptDocId and no parentMonthlyInvoiceId for individual receipt.');
    }
  }

  viewReceipt(event: MouseEvent | undefined, accountId: number, orderOrMonthlyInvoiceId: number, scId?: number) {
    this.saveTargetShortCode(event ?? scId);
    const nav = ['/dashboard',
      {
        outlets: {
          'navbar-tab': ['my-shortcodes', {
            outlets: {
              'my-shortcode-tab': scId ? ['receipt', orderOrMonthlyInvoiceId, scId] : ['receipt', orderOrMonthlyInvoiceId]
            }
          }]
        }
      }
    ];

    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.router.navigate(nav);
      });
    }
    else {
      this.router.navigate(nav);
    }

    window.scrollTo(0, 0);
  }


  viewPaymentReceipt(event: MouseEvent | undefined, accountId: number, paymentId: number) {
    this.saveTargetShortCode(event);

    const nav = [
      '/dashboard',
      {
        outlets: {
          'navbar-tab': ['my-shortcodes', {
            outlets: {
              'my-shortcode-tab': ['multiPaymentReceipt', paymentId]
            }
          }]
        }
      }
    ];

    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.router.navigate(nav);
      });
    }
    else {
      this.router.navigate(nav);
    }

    window.scrollTo(0, 0);
  }

  canViewPreviousPrepaidInvoice(shortCode: LeaseSummary): boolean {
    if (!shortCode.details) {
      return false;
    }
    const now = new Date();

    return (shortCode.leaseType === 'BilledMonthly' || !!shortCode.details.lease.mbOptOutDate) &&
      !isNumber(shortCode.details.monthlyInvoiceDocumentId) &&
      isNumber(shortCode.details.lease.parentOrderId) &&
      isNumber(shortCode.details.parentInvoiceId) &&
      isNumber(shortCode.details.parentInvoiceDocumentId) &&
      (shortCode.details.lease.startDate !== undefined) && (new Date(shortCode.details.lease.startDate) > now) &&
      (shortCode.details.parentLeaseMbOptOutDate === undefined);
  }

  viewPreviousPrepaidInvoice(event: MouseEvent | undefined, accountId: number, parentOrderId: number, parentPaymentId?: number): void {

    this.saveTargetShortCode(event);

    const nav = [
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', parentOrderId, parentPaymentId] } }] } }
    ];
    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.router.navigate(nav);
      });
    }
    else {
      this.router.navigate(nav);
    }
  }

  canViewPreviousPrepaidReceipt(shortCode: LeaseSummary): boolean {
    if (!shortCode.details) {
      return false;
    }
    const now = new Date();

    return (shortCode.leaseType === 'BilledMonthly' || !!shortCode.details.lease.mbOptOutDate) &&
      !isNumber(shortCode.details.monthlyInvoiceDocumentId) &&
      isNumber(shortCode.details.lease.parentOrderId) &&
      isNumber(shortCode.details.parentReceiptDocumentId) &&
      (shortCode.details.lease.startDate !== undefined) && (new Date(shortCode.details.lease.startDate) > now) &&
      (shortCode.details.parentLeaseMbOptOutDate === undefined);
  }

  viewPreviousPrepaidReceipt(event: MouseEvent | undefined, accountId: number, parentOrderId: number, parentPaymentId?: number): void {

    this.saveTargetShortCode(event);

    const nav = [
      '/dashboard',
      {
        outlets: {
          'navbar-tab': ['my-shortcodes', {
            outlets: {
              'my-shortcode-tab':
                parentPaymentId ? ['receipt', parentOrderId, parentPaymentId] : ['receipt', parentOrderId]
            }
          }]
        }
      }
    ];
    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.router.navigate(nav);
      });
    }
    else {
      this.router.navigate(nav);
    }
  }

  /**
   * We are about to navigate away from the list but need to save off the short code that
   * we want to scroll to when we return.  Find the row and use the id to record the short code.
   * @param clickEventOrScId - event that triggered the action or short code to save.
   */
  saveTargetShortCode(clickEventOrScId: MouseEvent | number | undefined): void {

    if (isNumber(clickEventOrScId)) {
      this.scrollToShortCode = clickEventOrScId;
      return;
    }

    if (clickEventOrScId?.target) {
      let el = clickEventOrScId.target as HTMLElement;
      while (el && el.tagName.toLowerCase() !== 'tr') {
        el = (el.parentElement as HTMLElement);
      }
      if (el) {
        const sib = el.previousElementSibling as HTMLElement;
        if (sib) {
          this.scrollToShortCode = parseInt(sib.id.split('_')[1]);
        }
      }
    }
  }

  viewInvoice(clickEvent: MouseEvent | number | undefined = undefined, accountId: number, orderId: number, paymentId?: number) {
    this.saveTargetShortCode(clickEvent);

    const nav = [
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': paymentId ? ['invoice', orderId, paymentId] : ['invoice', orderId] } }] } }
    ];

    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.router.navigate(nav);
      });
    }
    else {
      this.router.navigate(nav);
    }
  }

  viewMonthlyBillingEnrollmentStatement(clickEvent: MouseEvent | undefined, accountId: number, orderId: number) {
    this.saveTargetShortCode(clickEvent);

    const nav = [
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['statement', orderId] } }] } }
    ];

    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.router.navigate(nav);
      });
    }
    else {
      this.router.navigate(nav);
    }
  }

  renew(accountId: number, scId: number) {
    this.saveTargetShortCode(scId);

    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.doRenew(scId);
      });
    }
    else {
      this.doRenew(scId);
    }
  }

  doRenew(scId: number) {

    this.observe(this.shortCodesService.getRenewOrder(scId), (rsp: GetOrderForRenewResponse) => {
      const order = rsp.order;
      order.monthlyBillingEligible = rsp.monthlyBillingEligible;
      order.renew1Plus12 = rsp.renew1Plus12;
      if (order.monthlyBillingEligible) {
        order.monBillStartDateStr = rsp.monBillStartDateStr;
      }
      if (order.renew1Plus12) {
        order.renewalDeadLineStr = rsp.renewalDeadLineStr;
      }
      this.router.navigate(
        ['/dashboard',
          {
            outlets: {
              'navbar-tab':
                ['order-code',
                  { outlets: { 'order-code-tab': ['cart'] } }
                ]
            }
          }
        ], { state: { renew: true, needsactionRenew: (this.listMode === 'needsaction'), bulk: false, order: order } });
    });

    window.scrollTo(0, 0); // needed?
  }

  public bulkChecked(leaseId: string): void {
    this.clearMessages();
    // strangely, when you use the spacebar to select a checkbox, the "this.bulk" model is updated AFTER this bulkChecked
    // method is invoked.  When you use the mouse, it is called before.  Adding the setTimeout is a workaround.
    setTimeout(() => {
      if (this.bulk.length > this.bulkLimit && this.listMode === 'bulkrenew') {
        this.displayLocalizedWarning('scr.bulkrenewcountlimit', { count: this.bulkLimit });
        window.scrollTo(0, 0);
        this.bulk = this.bulk.filter(lid => lid != leaseId);
      } else if (this.bulk.length > this.bulkLimit && this.listMode === 'needsaction') {
        this.displayLocalizedWarning('scr.needsActionBulkrenewcountlimit', { count: this.bulkLimit });
        window.scrollTo(0, 0);
        this.bulk = this.bulk.filter(lid => lid != leaseId);
      }


      this.bulkSelectionCount = this.bulk.length;
    }, 100);
  }

  /**
   * When listMode is bulk renew, user can select up to 20 short codes for bulk renew.
   * Upon initiation of the bulk renew, call the back end API to create a candidate order
   * containing the selected short codes and navigate to the cart page.
   */
  doBulkRenew() {
    this.clearMessages();

    // TODO 9.5: will need to handle complex error results due to enhanced cp and brand validation.

    this.observe(this.shortCodesService.initiateBulkRenew(this.bulk.map(s => parseInt(s, 10))), {
      onSuccess: (rsp: GetOrderForRenewResponse) => {
        const order = rsp.order;
        order.bulkRenew = true;
        this.router.navigate(
          ['/dashboard',
            {
              outlets: {
                'navbar-tab':
                  ['order-code',
                    { outlets: { 'order-code-tab': ['cart'] } }
                  ]
              }
            }
          ], { state: { renew: false, bulk: true, order: order } });
        return false;
      },
      onFailure: (rsp: GetOrderForRenewResponse) => {
        if (rsp.messages) {
          const specials = rsp.messages.filter(m => m.code === '4094' || m.code === '4095' || m.code === '4096');
          const regular = rsp.messages.filter(m => m.code !== '4094' && m.code !== '4095' && m.code !== '4096');
          if (regular.length > 0) {
            rsp.messages = regular;
            this.doMessages(rsp);
          }
          if (specials.length > 0) {
            this.bulkRenewFailures = specials;
          }
          return false;
        }
        else {
          return true;
        }
      }
    });

    window.scrollTo(0, 0);
  }


  editDetails(shortCode: LeaseSummary) {
    this.saveTargetShortCode(shortCode.scId);
    this.router.navigate([
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['details', shortCode.scId] } }] } }
    ]);

    window.scrollTo(0, 0);
  }

  editBillingDetails(shortCode: LeaseSummary) {
    this.saveTargetShortCode(shortCode.scId);
    this.router.navigate([
      '/dashboard',
      { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['billingDetails', shortCode.scId] } }] } }
    ]);

    window.scrollTo(0, 0);
  }

  doAction(shortCode: LeaseSummary) {
    if (!shortCode.accountId) {
      console.error('no accountId with lease summary.  bailing');
      return;
    }
    switch (shortCode.settings?.clickAction) {
      case undefined:
        console.warn('how can there be a button with no click action');
        break;
      case 'invoice':
        this.viewInvoice(shortCode.scId, shortCode.accountId, shortCode.orderId);
        break;
      case 'renew':
        this.renew(shortCode.accountId, shortCode.scId);
        break;
      default:
        console.warn('not yet processing click action ' + shortCode.settings?.clickAction);
        break;
    }
  }

  showShortCodeTransferDialog(scId: number) {
    this.transferCode = scId;
    this.dialog.display = true;
    this.dialog.resetForm();

  }



  transferEventHandler(event: TransferEvent) {
    this.shortCodeDetails.delete(event.scId);
    this.getShortCodeDetails(event.scId);
    this.dialog.display = false;
  }

  /**
   * Download the transfer statement for the latest lease.
   * @param shortCode - lease summary of this short code
   */
  downloadTransferStatement(shortCode: LeaseSummary) {
    this.saveTargetShortCode(shortCode.scId);

    this.observeDownloadOrAny(this.shortCodesService.getTransferDoc(shortCode.scId), res => {
      this.shortCodesService.processBlobResponseDownload(res, 'application/pdf');
    });
  }

  navigateToOrder(accountId: number, orderId: number, needBackend = false): void {

    if (this.actionInterceptor && this.actionInterceptorSelf) {
      this.actionInterceptor.call(this.actionInterceptorSelf, accountId, () => {
        this.doNavigateToOrder(orderId, needBackend);
      });
    }
    else {
      this.doNavigateToOrder(orderId, needBackend);
    }
  }

  private doNavigateToOrder(orderId: number, needBackend = false): void {
    // do it ourselves.
    this.router.navigate([
      '/dashboard',
      { outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['view-orders'] } }] } }
    ], { state: { orderId, needBackend } });
  }

  loginAs(accountId: number | undefined, scId?: number): void {

    this.confirmationService.confirm({
      message:
        'Please confirm that you would like to log out and be returned to the Login page, so you can log in as the user for the selected account.',
      header: 'Log In to Linked Account',
      key: 'loginAs',
      accept: () => {
        this.accountService.getLinkedAccounts().pipe(first()).subscribe(rsp => {
          const linked = rsp.accounts.find(a => a.account?.accountId === accountId);
          if (!linked) {
            console.error('linked account ' + accountId + ' not found.');
            return;
          }
          this.scrAuthenticationService.logout().then(b => {
            this.log.debug('logout result ' + b);
            if (scId) {
              if (this.listMode.toLowerCase() === 'linkedaccounts-needsaction') {
                this.scrAuthenticationService.redirectUrl = `/redir/na/${scId}`;
              }
              else {
                this.scrAuthenticationService.redirectUrl = `/redir/sc/${scId}`;
              }
            }
            else {
              this.scrAuthenticationService.redirectUrl = undefined;
            }
            this.scrAuthenticationService.routeToLogin(linked.user?.userName ? linked.user.userName : undefined);
          });
        });
      }
    });
  }

  public reLoadShortCode(shortcode: number): void {
    // pending new cancel will delete the lease so we need to reload.
    // for other cancels, we can reload the details.
    if (this.leaseInfo.leaseStatus !== 'PendingNew') {
      this.loadShortCodeDetails(shortcode);
    }
    else {
      this.observe(this.determineListAPI(), (rsp) => {
        this.processTableData(rsp.data.leases);
        return false; // no message
      });
    }
  }

  showCancelLeaseShortCodeTransferErrorDialog() {
    this.cancelShortCodeLeasedialog.display = true;
    this.cancelShortCodeLeasedialog.resetForm();
  }

  showCancelLeaseDialog(shortCode: LeaseSummary) {
    this.clearMessages();
    this.cancelScid = shortCode.scId;
    this.cancelScOrderId = shortCode.orderId;
    this.leaseInfo = shortCode;
    this.shortCodesService.validateCancel(shortCode.scId, shortCode.leaseStatus, shortCode.orderId).subscribe((data: CancelValidation) => {
      this.leaseStatus = shortCode.leaseStatus;
      this.statusReason = shortCode.statusReason;

      if (data.status === 'fail') {
        this.clearMessages();
        if (data.messages) {
          const errorMsg = data?.messages[0].message;
          this.displayLocalizedError(errorMsg);
        }
      } else if (data.results.isError && data.results.information) {
        this.clearMessages();
        this.informationMessage = data.results.information;
        this.displayLocalizedError(this.informationMessage);
      }
      else {
        this.informationMessage = data.results.information;
        this.confirmationMessage = data.results.message;
        this.cancelShortCodeLeaseConfirmationDialog.display = true;
        this.cancelShortCodeLeaseConfirmationDialog.resetForm();
      }
    });
  }

  /**
   * When the list is empty, the message displayed depends on the list mode and other
   * factors.  Too complicated to make the HTML conditional so putting it here.
   * @returns translated string.
   */
  getEmptyListMessage(): Observable<string | undefined> {
    let rv: Observable<string | undefined>;
    switch (this.listMode) {
      case 'default': rv = this.translate.get('scr.emptyShortCodeList'); break;
      case 'needsaction': rv = this.translate.get('scr.emptyShortCodeListNeedsAction'); break;
      case 'bulkrenew': rv = this.translate.get('scr.emptyShortCodeListBulkRenew'); break;
      case 'linkedaccounts':
        if (!this.account.linkedAccountList || this.account.linkedAccountList.length === 0) {
          rv = this.translate.get('scr.emptyListNoLinkedAccounts');
        }
        else {
          rv = this.translate.get('scr.emptyShortCodeListLinkedAccounts');
        }
        break;
      case 'linkedaccounts-needsaction':
        if (!this.account.linkedAccountList || this.account.linkedAccountList.length === 0) {
          rv = this.translate.get('scr.emptyListNoLinkedAccounts');
        }
        else {
          rv = this.translate.get('scr.emptyShortCodeListLinkedAccountsNeedsAction');
        }
        break;
      default:
        rv = of(undefined);
    }
    return rv;
  }

  toggleBrandNames(sc: LeaseSummary) {
    this.leaseForBrandClientDialog = sc;
  }
}